const RESOURCES = Object.freeze({
  ar: {
    common: {
      hospitalJourney: 'رحلة المستشفى',
      backToJourney: 'العودة إلى {{title}}',
    },
    hospitalJourney: {
      ui: {
        people: {
          eyebrow: 'فريق رعايتك',
          visualDescription: 'تعرّف على من قد يشارك في رعايتك وكيف يمكنك التعرّف عليهم في هذا المستشفى.',
          showFewer: 'عرض أدوار أقل',
        },
        viewed: 'تم الاطلاع',
        stage: {
          label: 'المرحلة',
          fromHospital: 'من مستشفاك',
          fromHospitalDescription: 'معلومات رسمية من الجهة الصحية، تُفتح على موقعها الإلكتروني.',
        },
        roleBanner: {
          backToJourney: 'العودة إلى {{title}}',
          partOfGuide: 'هذا الدور جزء من {{title}}.',
        },
      },
    },
    roles: {
      items: {
        maternity_support_worker: {
          description: 'عاملة دعم تساعد القابلات والأسر أثناء رعاية الحمل والولادة.',
        },
        sonographer: {
          description: 'يستخدم التصوير بالموجات فوق الصوتية لإنشاء صور تساعد على تقييم أجزاء من الجسم أو متابعة الحمل.',
        },
      },
    },
  },
  fa: {
    common: { hospitalJourney: 'مسیر بیمارستان', backToJourney: 'بازگشت به {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'مرحله', fromHospital: 'از بیمارستان شما', fromHospitalDescription: 'اطلاعات رسمی مرکز درمانی شما که در وب‌سایت آن باز می‌شود.' }, roleBanner: { backToJourney: 'بازگشت به {{title}}', partOfGuide: 'این نقش بخشی از {{title}} است.' } } },
  },
  ur: {
    common: { hospitalJourney: 'ہسپتال کا سفر', backToJourney: '{{title}} پر واپس جائیں' },
    hospitalJourney: { ui: { stage: { label: 'مرحلہ', fromHospital: 'آپ کے ہسپتال سے', fromHospitalDescription: 'آپ کے ٹرسٹ کی سرکاری معلومات، جو اس کی ویب سائٹ پر کھلتی ہیں۔' }, roleBanner: { backToJourney: '{{title}} پر واپس جائیں', partOfGuide: 'یہ کردار {{title}} کا حصہ ہے۔' } } },
  },
  bn: {
    common: { hospitalJourney: 'হাসপাতাল যাত্রা', backToJourney: '{{title}}-এ ফিরে যান' },
    hospitalJourney: { ui: { stage: { label: 'পর্যায়', fromHospital: 'আপনার হাসপাতাল থেকে', fromHospitalDescription: 'আপনার ট্রাস্টের সরকারি তথ্য, যা তাদের ওয়েবসাইটে খুলবে।' }, roleBanner: { backToJourney: '{{title}}-এ ফিরে যান', partOfGuide: 'এই ভূমিকা {{title}}-এর অংশ।' } } },
  },
  gu: {
    common: { hospitalJourney: 'હોસ્પિટલ યાત્રા', backToJourney: '{{title}} પર પાછા જાઓ' },
    hospitalJourney: { ui: { stage: { label: 'તબક્કો', fromHospital: 'તમારી હોસ્પિટલ તરફથી', fromHospitalDescription: 'તમારા ટ્રસ્ટની સત્તાવાર માહિતી, જે તેમની વેબસાઇટ પર ખુલશે.' }, roleBanner: { backToJourney: '{{title}} પર પાછા જાઓ', partOfGuide: 'આ ભૂમિકા {{title}} નો ભાગ છે.' } } },
  },
  pa: {
    common: { hospitalJourney: 'ਹਸਪਤਾਲ ਯਾਤਰਾ', backToJourney: '{{title}} ਵੱਲ ਵਾਪਸ ਜਾਓ' },
    hospitalJourney: { ui: { stage: { label: 'ਪੜਾਅ', fromHospital: 'ਤੁਹਾਡੇ ਹਸਪਤਾਲ ਵੱਲੋਂ', fromHospitalDescription: 'ਤੁਹਾਡੇ ਟਰੱਸਟ ਦੀ ਸਰਕਾਰੀ ਜਾਣਕਾਰੀ, ਜੋ ਉਨ੍ਹਾਂ ਦੀ ਵੈੱਬਸਾਈਟ ਉੱਤੇ ਖੁੱਲ੍ਹੇਗੀ।' }, roleBanner: { backToJourney: '{{title}} ਵੱਲ ਵਾਪਸ ਜਾਓ', partOfGuide: 'ਇਹ ਭੂਮਿਕਾ {{title}} ਦਾ ਹਿੱਸਾ ਹੈ।' } } },
  },
  zh: {
    common: { hospitalJourney: '医院就诊旅程', backToJourney: '返回{{title}}' },
    hospitalJourney: { ui: { stage: { label: '阶段', fromHospital: '来自您的医院', fromHospitalDescription: '来自您所在医院信托的官方信息，将在其网站上打开。' }, roleBanner: { backToJourney: '返回{{title}}', partOfGuide: '此角色属于{{title}}。' } } },
  },
  fr: {
    common: { hospitalJourney: 'Parcours hospitalier', backToJourney: 'Retour à {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'Étape', fromHospital: 'De votre hôpital', fromHospitalDescription: 'Informations officielles de votre établissement, ouvertes sur son site web.' }, roleBanner: { backToJourney: 'Retour à {{title}}', partOfGuide: 'Ce rôle fait partie de {{title}}.' } } },
  },
  it: {
    common: { hospitalJourney: 'Percorso ospedaliero', backToJourney: 'Torna a {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'Fase', fromHospital: 'Dal tuo ospedale', fromHospitalDescription: 'Informazioni ufficiali della tua struttura, aperte sul suo sito web.' }, roleBanner: { backToJourney: 'Torna a {{title}}', partOfGuide: 'Questo ruolo fa parte di {{title}}.' } } },
  },
  pl: {
    common: { hospitalJourney: 'Ścieżka szpitalna', backToJourney: 'Wróć do {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'Etap', fromHospital: 'Z Twojego szpitala', fromHospitalDescription: 'Oficjalne informacje Twojego Trustu, otwierane na jego stronie internetowej.' }, roleBanner: { backToJourney: 'Wróć do {{title}}', partOfGuide: 'Ta rola jest częścią {{title}}.' } } },
  },
  pt: {
    common: { hospitalJourney: 'Percurso hospitalar', backToJourney: 'Voltar a {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'Etapa', fromHospital: 'Do seu hospital', fromHospitalDescription: 'Informação oficial da sua instituição, aberta no respetivo site.' }, roleBanner: { backToJourney: 'Voltar a {{title}}', partOfGuide: 'Esta função faz parte de {{title}}.' } } },
  },
  ro: {
    common: { hospitalJourney: 'Parcurs spitalicesc', backToJourney: 'Înapoi la {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'Etapă', fromHospital: 'De la spitalul dumneavoastră', fromHospitalDescription: 'Informații oficiale ale organizației dumneavoastră, deschise pe site-ul acesteia.' }, roleBanner: { backToJourney: 'Înapoi la {{title}}', partOfGuide: 'Acest rol face parte din {{title}}.' } } },
  },
  so: {
    common: { hospitalJourney: 'Safarka isbitaalka', backToJourney: 'Ku noqo {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'Marxalad', fromHospital: 'Ka socda isbitaalkaaga', fromHospitalDescription: 'Macluumaad rasmi ah oo ka socda hay’addaada caafimaad, laguna furayo boggeeda internetka.' }, roleBanner: { backToJourney: 'Ku noqo {{title}}', partOfGuide: 'Doorkan wuxuu qayb ka yahay {{title}}.' } } },
  },
  es: {
    common: { hospitalJourney: 'Recorrido hospitalario', backToJourney: 'Volver a {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'Etapa', fromHospital: 'De su hospital', fromHospitalDescription: 'Información oficial de su centro, que se abre en su sitio web.' }, roleBanner: { backToJourney: 'Volver a {{title}}', partOfGuide: 'Este rol forma parte de {{title}}.' } } },
  },
  tl: {
    common: { hospitalJourney: 'Paglalakbay sa ospital', backToJourney: 'Bumalik sa {{title}}' },
    hospitalJourney: { ui: { stage: { label: 'Yugto', fromHospital: 'Mula sa iyong ospital', fromHospitalDescription: 'Opisyal na impormasyon mula sa iyong Trust, na bubukas sa kanilang website.' }, roleBanner: { backToJourney: 'Bumalik sa {{title}}', partOfGuide: 'Bahagi ang tungkuling ito ng {{title}}.' } } },
  },
  tr: {
    common: { hospitalJourney: 'Hastane yolculuğu', backToJourney: '{{title}} bölümüne dön' },
    hospitalJourney: { ui: { stage: { label: 'Aşama', fromHospital: 'Hastanenizden', fromHospitalDescription: 'Sağlık kuruluşunuzun kendi internet sitesinde açılan resmî bilgileri.' }, roleBanner: { backToJourney: '{{title}} bölümüne dön', partOfGuide: 'Bu rol {{title}} bölümünün bir parçasıdır.' } } },
  },
});

function languageCode(language) {
  return String(language || '').toLowerCase().split('-')[0];
}

export function installPatientJourneyTranslationGapResources(i18n, language, namespace) {
  const code = languageCode(language);
  const resources = RESOURCES[code];
  if (!resources || !namespace || !resources[namespace]) return;
  i18n.addResourceBundle(code, namespace, resources[namespace], true, true);
}

export default RESOURCES;
